"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const Typography_1 = __importDefault(require("../Typography"));
const Pill = (props) => {
    const { forwardedRef, className, label, id, leadingIcon } = props, restProps = __rest(props, ["forwardedRef", "className", "label", "id", "leadingIcon"]);
    const finalClassName = classnames_1.default(`pill`, className);
    return (react_1.default.createElement("label", { className: finalClassName },
        react_1.default.createElement("input", Object.assign({ id: id, className: 'pill__input', type: 'checkbox', ref: forwardedRef, "aria-checked": props.checked, "aria-label": label, "aria-labelledby": `${id}-label`, "aria-describedby": `${id}-label`, "aria-errormessage": props['aria-errormessage'] }, restProps)),
        react_1.default.createElement(Typography_1.default, { as: 'span', type: 'label-sm', className: 'pill__label' },
            leadingIcon,
            label)));
};
exports.Pill = Pill;
exports.Pill.displayName = 'Pill';
exports.default = ForwardRefHOC_1.default(exports.Pill);
